<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-parse-success`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44.264 30.707l1.414 1.414a1 1 0 010 1.414l-9.9 9.9a1 1 0 01-1.414 0l-5.657-5.657a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0l3.535 3.535 7.778-7.778a1 1 0 011.415 0zM28 6c9.941 0 18 8.059 18 18 0 .69-.039 1.372-.115 2.043h-4.033c.098-.667.148-1.35.148-2.043 0-7.732-6.268-14-14-14a14.007 14.007 0 00-13.312 9.65l-.673 2.06-2.094.562A8.005 8.005 0 006 30a8 8 0 008 8h9.817l3.849 4H14C7.373 42 2 36.627 2 30c0-5.55 3.768-10.22 8.886-11.592C13.238 11.205 20.01 6 28 6z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudParseSuccess',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
